import { clsx } from "clsx";
import type { ReactNode } from "react";
import { Text } from "../typography";

export type BannerTone = "success" | "error" | "warning";

export interface BannerProps {
  tone: BannerTone;
  icon?: ReactNode;
  className?: string;
  children: ReactNode;
}

const TONE: Record<BannerTone, { bg: string; text: string }> = {
  success: { bg: "bg-accentGreenTint", text: "text-accentGreenDark" },
  error: { bg: "bg-accentErrorTint", text: "text-accentError" },
  warning: { bg: "bg-accentYellowTint", text: "text-textBody" },
};

export function Banner({ tone, icon, className, children }: BannerProps) {
  const style = TONE[tone];
  return (
    <div
      role={tone === "error" ? "alert" : "status"}
      className={clsx(
        "flex items-center rounded-xl px-4 py-3",
        icon ? "gap-3 justify-start" : "justify-center",
        style.bg,
        className,
      )}
    >
      {icon && <span className="inline-flex shrink-0 text-textBody">{icon}</span>}
      <Text variant="bodyBold" inline className={style.text}>
        {children}
      </Text>
    </div>
  );
}
